// extracted by mini-css-extract-plugin
export default {"section":"ReservationSection_section__7tdqp","overlay":"ReservationSection_overlay__q9GzI","content":"ReservationSection_content__axmgz"};